import { render, staticRenderFns } from "./SettingItem-bv.vue?vue&type=template&id=581e5500"
import script from "./SettingItem-bv.vue?vue&type=script&lang=js"
export * from "./SettingItem-bv.vue?vue&type=script&lang=js"
import style0 from "./SettingItem-bv.vue?vue&type=style&index=0&id=581e5500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports